import { GalleryMedium } from "features/gallery/gallery.types"
import { eventMediaApi } from "store/api"

export async function getGalleryMedia(
  postId: number,
  offset: number,
  limit: number
): Promise<GalleryMedium[]> {
  const response = await eventMediaApi.getEventMedia(
    postId.toString(),
    offset,
    limit,
    "asc"
  )
  return response.data
}
